import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WidgetInstance } from 'friendly-challenge';
import { Observable, Subscriber } from 'rxjs';
import { REST_BASE_URL } from '../app.config';
import { EnvironmentConfigService } from './environment-config.service';

@Injectable({
  providedIn: 'root'
})
export class FriendlyCaptchaService {

  constructor(private _httpClient: HttpClient, private environmentConfigService: EnvironmentConfigService) { }

  startFriendlyCaptcha() {
    if (!this.isCaptchaEnabled) {
      return;
    }

    const savedSolution= this.friendlyCaptchaSolution;
    if (savedSolution) {
      return;
    } else {
      this.getSolution().subscribe();
    }
  }

  getSolution() {
    return new Observable<CaptchaSolution>(subscriber => {
      const container = document.createElement("div");
      container.style.display = "none";
      document.body.appendChild(container);
      this._initWidget(container, subscriber);
    })
  }

  get friendlyCaptchaSolution(): CaptchaSolution {
    const savedSolution = JSON.parse(sessionStorage.getItem("solution"));
    if (!savedSolution) {
      return null;
    }

    const solutionValue = savedSolution.solution;
    const solutionExpired = new Date().getTime() > savedSolution.expirationDate;
    if (!solutionValue || solutionExpired) {
      return null;
    }

    return savedSolution;
  }

  get isCaptchaEnabled() {
    return this.environmentConfigService && this.environmentConfigService.getEnvConfig() && this.environmentConfigService.getEnvConfig().captchaEnabled;
  }

  private _initWidget(container: HTMLElement, subscriber: Subscriber<CaptchaSolution>) {
    const widget = new WidgetInstance(container, {
      sitekey: this.environmentConfigService.getEnvConfig().siteKey,
      startMode: 'auto',
      doneCallback: solution => {
        this._completeHandler(solution, subscriber);
        this._cleanup(container, widget);
      },
      errorCallback: (error) => {
        this._cleanup(container, widget);
        subscriber.error(error);
      }
    });

    return widget;
  }

  private _completeHandler = (solution: string, subscriber: Subscriber<CaptchaSolution>) => {
    this._httpClient.post<{ solution: string }>(CAPTCHA_BACKEND_URL, {solution: solution})
    .subscribe({
      next: value => {
        const numberOfHoursInMilliseconds  = this.environmentConfigService.getEnvConfig().captchaSolutionCacheDurationHours * 60 * 60 * 1000;
        const solution: CaptchaSolution = {solution: value.solution, expirationDate: new Date().getTime() + numberOfHoursInMilliseconds};
        sessionStorage.setItem("solution", JSON.stringify(solution));
        subscriber.next(solution);
        subscriber.complete();
      },
      error: e => subscriber.error(e)
    });
  }

  private _cleanup(container: HTMLElement, widget: WidgetInstance) {
    widget.destroy();
    try { document.body.removeChild(container); } catch {}
  }
}

export interface CaptchaSolution {
  solution: string;
  expirationDate: number;
}

export const CAPTCHA_BACKEND_URL = `${ REST_BASE_URL }/captcha`;
